<!-- licencias.component.html -->
<app-breadcrumb [title]="'Empresas Activas'" [items]="['Empresarial']"
  [active_item]="'Empresas Activas'"></app-breadcrumb>

<div class="container-fluid">
  <div class="card">
    <div class="card-header d-flex align-items-center bg-primary text-white">
      <i class="icofont icofont-briefcase-alt-1 me-2"></i>
      <h5 class="mb-0"><strong>LISTADO DE EMPRESAS ACTIVAS</strong></h5>
    </div>

    <div class="card-body custom-datatable noscroll">
      <div class="row mb-12">
        <div class="col-sm-12 col-md-3 ms-auto">
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Buscar....." [(ngModel)]="searchText"
              (input)="filterData()" />
            <span class="input-group-text">
              <i class="fa fa-search"></i> <!-- Icono de búsqueda -->
            </span>
          </div>
        </div>
      </div>

      <div class="custom-datatable table-responsive mt-4">
        <table class="table table-hover table-bordered" id="tblEmpresasActivas">
          <thead>
            <tr class="bg-primary">
              <th class="text-center text-white" (click)="sortData('nit')" style="cursor: pointer;">
                <strong>NIT</strong>
                <i class="fa ms-1" [ngClass]="{
                'fa-sort-up': sortColumn === 'nit' && sortDirection === 'asc',
                'fa-sort-down': sortColumn === 'nit' && sortDirection === 'desc',
                'fa-sort': sortColumn !== 'nit'
              }"></i>
              </th>
              <th class="text-center text-white" (click)="sortData('digito')" style="cursor: pointer;">
                <strong>DIGITO</strong>
                <i class="fa ms-1" [ngClass]="{
                'fa-sort-up': sortColumn === 'digito' && sortDirection === 'asc',
                'fa-sort-down': sortColumn === 'digito' && sortDirection === 'desc',
                'fa-sort': sortColumn !== 'digito'
              }"></i>
              </th>
              <th class="text-center text-white" (click)="sortData('nombre')" style="cursor: pointer;">
                <strong>EMPRESA</strong>
                <i class="fa ms-1" [ngClass]="{
                'fa-sort-up': sortColumn === 'nombre' && sortDirection === 'asc',
                'fa-sort-down': sortColumn === 'nombre' && sortDirection === 'desc',
                'fa-sort': sortColumn !== 'nombre'
              }"></i>
              </th>
              <th class="text-center text-white" (click)="sortData('tipo')" style="cursor: pointer;">
                <strong>TIPO EMPRESA</strong>
                <i class="fa ms-1" [ngClass]="{
                'fa-sort-up': sortColumn === 'tipo' && sortDirection === 'asc',
                'fa-sort-down': sortColumn === 'tipo' && sortDirection === 'desc',
                'fa-sort': sortColumn !== 'tipo'
              }"></i>
              </th>
              <th class="text-center text-white" (click)="sortData('direccion')" style="cursor: pointer;">
                <strong>DIRECCIÓN</strong>
                <i class="fa ms-1" [ngClass]="{
                'fa-sort-up': sortColumn === 'direccion' && sortDirection === 'asc',
                'fa-sort-down': sortColumn === 'direccion' && sortDirection === 'desc',
                'fa-sort': sortColumn !== 'direccion'
              }"></i>
              </th>
              <th class="text-center text-white" (click)="sortData('telefono')" style="cursor: pointer;">
                <strong>TELÉFONO</strong>
                <i class="fa ms-1" [ngClass]="{
                'fa-sort-up': sortColumn === 'telefono' && sortDirection === 'asc',
                'fa-sort-down': sortColumn === 'telefono' && sortDirection === 'desc',
                'fa-sort': sortColumn !== 'telefono'
              }"></i>
              </th>
              <th class="text-center text-white" (click)="sortData('celular')" style="cursor: pointer;">
                <strong>CELULAR</strong>
                <i class="fa ms-1" [ngClass]="{
                'fa-sort-up': sortColumn === 'celular' && sortDirection === 'asc',
                'fa-sort-down': sortColumn === 'celular' && sortDirection === 'desc',
                'fa-sort': sortColumn !== 'celular'
              }"></i>
              </th>
              <th class="text-center text-white" (click)="sortData('email')" style="cursor: pointer;">
                <strong>EMAIL</strong>
                <i class="fa ms-1" [ngClass]="{
                'fa-sort-up': sortColumn === 'email' && sortDirection === 'asc',
                'fa-sort-down': sortColumn === 'email' && sortDirection === 'desc',
                'fa-sort': sortColumn !== 'email'
              }"></i>
              </th>
              <th class="text-center text-white"><strong>OPCIONES</strong></th>
            </tr>

          </thead>

          <tbody>
            <tr *ngFor="
                let empresa of empresas of filteredTableItems
                  | paginate : { itemsPerPage: pageSize, currentPage: page };
                let i = index
              ">
              <td class="text-center">{{ empresa.nit }}</td>
              <td class="text-center">{{ empresa.digito }}</td>
              <td class="text-uppercase text-justify">{{ empresa.nombre }}</td>
              <td class="text-uppercase text-justify">
                <ng-container *ngFor="let cat of empresa.categorias">
                  <span *ngIf="cat" class="badge me-1" [ngClass]="cat.class">
                    &bull; {{ cat.text }}
                  </span>
                </ng-container>
              </td>
              <td class="text-uppercase text-justify">{{ empresa.direccion }}</td>
              <td class="text-center">{{ empresa.telefono }}</td>
              <td class="text-center">{{ empresa.celular }}</td>
              <td class="text-center">{{ empresa.email }}</td>
              <td>
                <div class="action text-center">
                  <ul class="list-inline">
                    <li class="edit">
                      <a href="javascript:void(0)"><i class="icon-pencil-alt" ngbTooltip="Editar Empresa" *ngIf="auth.hasPermiso('empresarial.editar')"
                          (click)="openModalEmpresas(myModal, empresa)"></i></a>
                    </li>
                    <li class="delete" (click)="inactivarPersona(empresa.nit)">
                      <a href="javascript:void(0)"><i class="icon-trash" ngbTooltip="Inactivar Empresa" *ngIf="auth.hasPermiso('empresarial.inactivar')"></i></a>
                    </li>
                    <li class="list-inline-item">
                      <div ngbDropdown container="body">
                        <button type="button" class="btn btn-primary" ngbDropdownToggle>
                          Digitales
                        </button>
                      
                        <div ngbDropdownMenu>
                          <button ngbDropdownItem type="button" (click)="cargarDocumentos(empresa.nit)">
                            Cargar Documentos
                          </button>
                      
                          <button ngbDropdownItem type="button" (click)="VerDocumentos(empresa.nit)">
                            Ver Documentos
                          </button>
                        </div>
                      </div>
                      </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        
        <div class="row align-items-center mt-4 g-2">
          <!-- Selector de registros por página -->
          <div class="col-12 col-md-4 d-flex align-items-center justify-content-center justify-content-md-start">
            <label for="pageSize" class="me-2 mb-0">Mostrar:</label>
            <select id="pageSize" class="form-select w-auto" [(ngModel)]="pageSize" (change)="page = 1">
              <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
            </select>
            <span class="ms-2">registros por página</span>
          </div>

          <!-- Total de registros -->
          <div class="col-12 col-md-4 text-center my-2 my-md-0">
            Total Registros:
            <a class="badge badge-primary"><b>{{ filteredTableItems?.length }}</b></a>
          </div>

          <!-- Paginador -->
          <div class="col-12 col-md-4 text-center text-md-end">
            <pagination-controls 
              (pageChange)="page = $event" 
              [maxSize]="5"
              [directionLinks]="true"
              [autoHide]="true"
              previousLabel="Anterior" 
              nextLabel="Siguiente">
            </pagination-controls>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="btn-showcase text-center">
          <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
            (click)="exportarExcel('tblEmpresasActivas', 'Listado_Empresas_Activas')">
            <i class="icofont icofont-file-excel"></i> EXCEL
          </button>

          <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF" (click)="
              exportToPDF(
                'tblEmpresasActivas',
                'Listado_Empresas_Activas',
                'Listado de Empresas Activas'
              )
            ">
            <i class="icofont icofont-file-pdf"></i> PDF
          </button>
        </div>
      </div>

      <ng-template #myModal let-modal>
        <div class="card border-4 rounded-3">
          <form [formGroup]="formEmpresa">
            <div
              class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
              <h5 class="mb-0"><strong>DATOS DE EMPRESA</strong></h5>
              <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="cerrarModal(modal)">
              </button>
            </div>
            <div class="card-body">
              <div class="row g-3">
                <div class="col-md-3">
                  <label class="form-label" for="nit"><strong>CC / NIT</strong></label>
                  <input class="form-control" id="nit" type="number" placeholder="" formControlName="nit" />
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="digito">
                   <strong>Digito de Verificacción *:</strong></label>
                  <input class="form-control" id="digito" type="number" placeholder="" formControlName="digito" />
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="nombre">
                    <strong>Nombre Completo/Razon Social</strong></label>
                  <input class="form-control" id="nombre" type="text" placeholder="" formControlName="nombre" />
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="direccion"> <strong>Dirección</strong></label>
                  <input class="form-control" id="direccion" type="text" placeholder="" formControlName="direccion" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="ciudad"><strong>Ciudad *:</strong></label>
                  <ng-select #inputCiudad id="ciudad" [items]="municipios" bindLabel="MUNICIPIO" bindValue="IDMUN"
                    placeholder="Selecciona una ciudad" class="js-example-placeholder-multiple" name="lugarex" required
                    formControlName="ciudad"
                    [class.is-invalid]="formEmpresa.get('ciudad')?.invalid && validate"></ng-select>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="telefono">
                    <strong>Teléfono fijo:</strong></label>
                  <input class="form-control" id="telefono" type="number" placeholder="" formControlName="telefono"
                    (input)="limitarLongitud($event, 10)" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="celular">
                    <strong>Teléfono celular *:</strong></label>
                  <input class="form-control" id="celular" type="text" placeholder="" formControlName="celular"
                    (input)="limitarLongitud($event, 10)" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="email">
                    <strong>Correo electrónico :</strong></label>
                  <input class="form-control" id="email" type="text" placeholder="" formControlName="email" />
                </div>
                <div class="row g-3 mb-3">
                  <div class="mb-3">
                    <label><strong>Observaciones:</strong></label>
                    <textarea class="form-control" id="observaciones" rows="3"
                      formControlName="observaciones"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
              <h5 class="mb-0"><strong>TIPO DE EMPRESAS</strong></h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <label class="d-block" for="chk-ani1">
                    <input class="checkbox_animated me-2" id="chk-ani1" type="checkbox" formControlName="eps" />
                    <strong>EPS (SALUD)</strong>
                  </label>
                  <label class="d-block" for="chk-ani2">
                    <input class="checkbox_animated me-2" id="chk-ani2" type="checkbox" formControlName="arl" />
                    <strong>ARL (RIEGOS LABORALES)</strong>
                  </label>
                  <label class="d-block" for="chk-ani3">
                    <input class="checkbox_animated me-2" id="chk-ani3" type="checkbox" formControlName="afp" />
                    <strong>AFP (FONDO DE PENSIONES)</strong>
                  </label>
                  <label class="d-block" for="chk-ani4">
                    <input class="checkbox_animated me-2" id="chk-ani4" type="checkbox" formControlName="ces" />
                    <strong>CES (CESANTIAS)</strong>
                  </label>
                  <label class="d-block" for="chk-ani5">
                    <input class="checkbox_animated me-2" id="chk-ani5" type="checkbox" formControlName="ccf" />
                    <strong>CCF (CAJA DE COMPESANCIÓN FAMILIAR)</strong>
                  </label>
                  <label class="d-block" for="chk-ani6">
                    <input class="checkbox_animated me-2" id="chk-ani6" type="checkbox" formControlName="bancos" />
                    <strong>BANCOS</strong>
                  </label>
                </div>
                <div class="col-md-4">
                  <label class="d-block" for="chk-ani7">
                    <input class="checkbox_animated me-2" id="chk-ani7" type="checkbox"
                      formControlName="transporte" /><strong>EMPRESA DE TRANSPORTES</strong>
                  </label>
                  <label class="d-block" for="chk-ani8">
                    <input class="checkbox_animated me-2" id="chk-ani8" type="checkbox" formControlName="colegio" />
                    <strong>COLEGIO</strong>
                  </label>
                  <label class="d-block" for="chk-ani9">
                    <input class="checkbox_animated me-2" id="chk-ani9" type="checkbox" formControlName="cda" />
                    <strong>CDA</strong>
                  </label>
                  <label class="d-block" for="chk-ani10">
                    <input class="checkbox_animated me-2" id="chk-ani10" type="checkbox" formControlName="taller" />
                    <strong>TALLER MECÁNICO</strong>
                  </label>
                  <label class="d-block" for="chk-ani11">
                    <input class="checkbox_animated me-2" id="chk-ani11" type="checkbox" formControlName="eds" />
                    <strong>EDS</strong>
                  </label>
                  <label class="d-block" for="chk-ani12">
                    <input class="checkbox_animated me-2" id="chk-ani12" type="checkbox"
                      formControlName="contratista" />
                   <strong>CLIENTES/CONTRATANTES</strong>
                  </label>
                </div>
                <div class="col-md-4">
                  <label class="d-block" for="chk-ani13">
                    <input class="checkbox_animated me-2" id="chk-ani13" type="checkbox" formControlName="proveedor" />
                    <strong>PROVEEDOR</strong>
                  </label>
                  <label class="d-block" for="chk-ani14">
                    <input class="checkbox_animated me-2" id="chk-ani14" type="checkbox"
                      formControlName="aseguradora" />
                    <strong>ASEGURADORA</strong>
                  </label>
                  <label class="d-block" for="chk-ani16">
                    <input class="checkbox_animated me-2" id="chk-ani16" type="checkbox" formControlName="almacen" />
                    <strong>ALMACÉN DE REPUESTO</strong>
                  </label>
                  <label class="d-block" for="chk-ani17">
                    <input class="checkbox_animated me-2" id="chk-ani17" type="checkbox" formControlName="serviteca" />
                    <strong>SERVITECAS</strong>
                  </label>
                   <label class="d-block" for="chk-ani18">
                    <input class="checkbox_animated me-2" id="chk-ani18" type="checkbox" formControlName="entidad">
                    <strong> ENTIDAD</strong>
                  </label>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-primary" (click)="guardarEmpresas()">
                {{ editMode ? "Actualizar" : "Guardar" }}
              </button>
              <button class="btn btn-secondary" (click)="cerrarModal(modal)">
                Cancelar
              </button>
            </div>
          </form>
        </div>
      </ng-template>
    </div>
  </div>
</div>